<template>
  <div>
    <main class="container-fluid">
      <section class="row">
        <div class="col-4 px-3 py-3 d-none d-md-flex"></div>
        <div
          class="col-md-16 px-md-3 py-md-3 pt-3 pt-md-0 px-3 px-md-0 mb-md-5"
        >
          <div class="col d-column">
            <h1 class="title pt-2 mb-0" v-text="$ml.get('generalRanking')"></h1>
            <h1 class="title">
              <span v-text="$ml.get('expertRating')" class="pb-2"></span>
            </h1>

            <div class="d-flex align-items-center mb-4" style="gap: 5px">
              <div>
                <img src="../assets/icons/trofeu-ranking.svg" width="26" />
              </div>
              <h5 class="m-0">Top 15 Hunters</h5>
            </div>

            <CardTopRanking :top3Visual="top3Visual" />

            <div class="mb-3">
              <div class="">
                <div class="d-column flex-row">
                  <div class="loading d-flex">
                    <div v-if="loading" class="c-loader"></div>
                    <h6
                      v-else
                      v-show="!itensRank.length"
                      class="p-1"
                      v-text="$ml.get('rankingDoesNotHaveEnoughDataYet')"
                    >
                      O Ranking ainda não tem dados suficientes
                    </h6>
                  </div>

                  <div
                    v-for="(item, index) in itensRank"
                    :key="index"
                    class="ranking-item-list"
                  >
                    <div
                      v-if="index > 2"
                      :class="
                        'h-profile d-flex pt-3 pb-3 align-items-center ' +
                        (itensRank.length == index + 1 ? 'no' : '')
                      "
                    >
                      <div class="d-flex">
                        <div>
                          <span class="p-2 idx-ranking">{{ index + 1 }}°</span>
                        </div>
                      </div>
                      <div
                        class="position-relative align-self-center d-flex align-items-center align-self-center"
                      >
                        <object
                          width="42"
                          height="42"
                          :data="item.avatar"
                          type="image/png"
                        >
                          <img
                            width="42"
                            height="42"
                            src="../assets/images/default.png"
                            alt="Avatar hacker"
                          />
                        </object>

                        <div v-if="item.verified" class="verify">
                          <img
                            src="../../src/assets/icons/badge-check.png"
                            width="16"
                            height="16"
                          />
                        </div>
                      </div>

                      <div
                        class="pl-3 d-flex align-items-center d-flex justify-content-between"
                        style="flex: 1"
                      >
                        <div class="align-self-start">
                          <h3>
                            <a
                              href=""
                              class="link-block"
                              v-text="item.username"
                              @click.prevent
                            ></a>
                          </h3>
                        </div>
                      </div>

                      <div class="d-flex align-items-center" style="gap: 10px">
                        <p
                          class="mt-1 text-dark d-flex justify-content-center"
                          style="width: 100px"
                        >
                          <span
                            style="
                              font-size: 18px;
                              font-weight: 500;
                              color: #343a40;
                            "
                          >
                            {{ item.score }}</span
                          >

                          <font class="pl-1">pts</font>
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </main>
  </div>
</template>

<script>
import RankingService from "../services/ranking.service";
import CardTopRanking from "../components/ranking/CardTopRanking.vue";

export default {
  components: {
    CardTopRanking,
  },
  data() {
    return {
      loading: true,
      value: null,
      itensRank: [],
      top3: [],
    };
  },
  mounted() {
    this.changeDados();
  },

  computed: {
    top3Visual() {
      if (this.top3.length < 3) return this.top3;

      return [
        this.top3.find((item) => item.lugar === 2),
        this.top3.find((item) => item.lugar === 1),
        this.top3.find((item) => item.lugar === 3),
      ];
    },
  },

  methods: {
    async changeDados() {
      this.loading = true;
      this.itensRank = [];
      RankingService.getRankingGeral(0, 15).then(
        (response) => {
          this.loading = false;
          this.itensRank = response.data.items;

          this.top3 = response.data.items
            .sort((a, b) => b.score - a.score)
            .slice(0, 3)
            .map((item, index) => ({
              ...item,
              lugar: index + 1,
            }));

          this.totalPages = response.data.total;
        },
        () => {
          this.loading = false;
        },
      );
    },
  },
};
</script>
